import { SlashForwardIcon } from './SlashForwardIcon';

/**
 * author: Michael Irigoyen
 * id 355F6D86-E6B6-4EA4-91BA-95370240E9CF
 * name slash-forward
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/slash-forward.svg
 * tags
 * - Math 
 */
export const DivideIcon = SlashForwardIcon;
export default DivideIcon